import { Button, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material'
import type { ReactNode } from 'react'
import { useCallback, useState } from 'react'

import { Dialog, PhxIcon } from '@salsita-ai/platform-project-sdk/ui'

export const HelpButton = (props: { title: ReactNode; children: ReactNode }) => {
  const { title, children } = props
  const [isOpen, setOpen] = useState(false)

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  return (
    <>
      <IconButton onClick={handleOpen}>
        <PhxIcon name="Info" />
      </IconButton>
      <Dialog.Root isOpen={isOpen} onClose={handleClose} sx={{ maxWidth: 800 }}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog.Root>
    </>
  )
}
